/* @flow */
import apiRequest from 'lib/apiRequest';

const FamilyActions = {
  sendConsentForm(childId: Backbone$Id) {
    return apiRequest('/family/send_vpc_form', 'POST', {
      child_id: childId,
    });
  },
  sendConsentFile(childId: Backbone$Id, consentFileUuid: string) {
    return apiRequest('/family/verify', 'POST', {
      child_id: childId,
      signature_file_uuid: consentFileUuid,
    });
  },
  sendConsentPayment(childId: Backbone$Id, sourceId: string, cardOwnerName: string) {
    return apiRequest('/family/verify', 'POST', {
      child_id: childId,
      charge: {
        source_id: sourceId,
        cardowner_name: cardOwnerName,
      },
    });
  },
};

export default FamilyActions;
